// this is a special hyphen called an "emdash", which is slightly wider
// than the standard hyphen
export const EMPTY_CONTENT_HYPHEN = '—';
